import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TaskOpenIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="taskOpen" ref={ref} {...props}>
      <path d="M12,22.75A10.75,10.75,0,1,1,22.75,12,10.76,10.76,0,0,1,12,22.75Zm0-20A9.25,9.25,0,1,0,21.25,12,9.26,9.26,0,0,0,12,2.75Zm3.54,11.59c0-2.25-2.19-2.86-3.24-3.15L12,11.12c-1.36-.37-2-.67-2-1.47,0-1.2,1.5-1.47,2-1.47A2.57,2.57,0,0,1,14.21,9a.75.75,0,0,0,1.06,0A.75.75,0,0,0,15.3,8a4.05,4.05,0,0,0-3.2-1.33c-1.71,0-3.53,1-3.53,3s2,2.62,3.08,2.92l.25.06c1.36.38,2.14.78,2.14,1.71C14,15.52,12.82,16,12,16a3.24,3.24,0,0,1-2.35-.77.75.75,0,1,0-1.18.92A4.53,4.53,0,0,0,12,17.45,3.29,3.29,0,0,0,15.54,14.34Z" />
    </Icon>
  ),
) as IconWithRender;

TaskOpenIcon.displayName = 'TaskOpenIcon';
TaskOpenIcon.renderIcon = (props) => <TaskOpenIcon {...props} />;
export default TaskOpenIcon;
